import { setNavigationEvents, setPaginationEvents } from "./pagination";
import { setClearFilters, setEventFilterCheckBox, setEventInsideResponseFilter, setOrderEvent } from "./filters";
import { performSearch } from "./search-hub";

const formSearch = document.getElementById("search-form");

let currentAbortController = null;

if (formSearch) {

    const dataNotFoundFlag = document.querySelectorAll('div[data-found="no-result"]');

    if (dataNotFoundFlag.length === 0) {

        const previousPageElement = document.querySelector(".pagination-js-search-previous");
        const nextPageElement = document.querySelector(".pagination-js-search-next");
        const paginationElements = document.getElementsByClassName("pagination-js-search");
    
        const filtersCheckboxes = document.querySelectorAll(".js-filter-checkbox");
        const clearAll = document.querySelector(".js-clear-filters");
        const tagsInResponse = document.getElementsByClassName("js-in-response-filter");

        const filterOrder = document.querySelector(".js-filter-order");
    
        formSearch.addEventListener('submit', (e) => {
            e.preventDefault();
            performSearch(1, formSearch, currentAbortController);
        });
    
        //set up the navigation options
        setPaginationEvents(paginationElements, formSearch, currentAbortController);
        setNavigationEvents(previousPageElement, formSearch, currentAbortController);
        setNavigationEvents(nextPageElement, formSearch, currentAbortController);
    
        //set up the filter options
        setClearFilters(filtersCheckboxes, clearAll, formSearch, currentAbortController);
        setEventFilterCheckBox(filtersCheckboxes, formSearch, currentAbortController);
        setEventInsideResponseFilter(tagsInResponse, formSearch, currentAbortController);

        setOrderEvent(filterOrder, formSearch, currentAbortController);
        
    }
}


